import { useState, useRef } from 'react';
import Grid from '@atoms/Grid/Grid';
import VoucherCard from '@molecules/VoucherCard/VoucherCard';
import ProductsWithTracking from '@molecules/ProductsWithTracking/ProductsWithTracking';
import type { AxfoodExternalVoucher, AxfoodBasicProductViewModel } from '@occ/api-client';

type Variant = 'product' | 'mixmatch';

type Vouchers = {
  used: AxfoodExternalVoucher[];
  available: AxfoodExternalVoucher[];
};

interface Props {
  title: string;
  products: Array<AxfoodBasicProductViewModel | ImageGridComponentType>;
  category?: string;
  vouchers?: Vouchers;
  productType: OnlineOfflineProductType;
  offline?: boolean;
  variant?: Variant;
  hideAddToList?: boolean;
  disableMixMatchButton?: boolean;
  limit?: number;
  numberOfGridCols?: number;
}

const ProductContainer = ({
  title,
  products = [],
  category = title,
  vouchers,
  productType,
  offline,
  variant = 'product',
  hideAddToList = false,
  disableMixMatchButton = false,
  limit = products?.length || 0,
  numberOfGridCols,
}: Props) => {
  const [currentMixMatchBeam, setCurrentMixMatchBeam] = useState<string>('');
  const gridRef = useRef<HTMLDivElement>(null);

  const setOpenMixMatchBeam = (code: string) => setCurrentMixMatchBeam(code);

  const getProductKey = (product: AxfoodBasicProductViewModel | ImageGridComponentType) => {
    if ('typeCode' in product) {
      return product?.code;
    }
    return `${productType}-${product?.code || product.potentialPromotions[0]?.code}`;
  };

  return (
    <Grid ref={gridRef}>
      {vouchers?.available?.map((voucher) => (
        <VoucherCard voucher={voucher} key={voucher.voucherId} productType={productType} />
      ))}

      {vouchers?.used?.map((voucher) => (
        <VoucherCard voucher={voucher} key={voucher.voucherId} productType={productType} />
      ))}

      {products && products.length > 0 && (
        <ProductsWithTracking
          products={products}
          variant={variant}
          getKey={getProductKey}
          category={category}
          offline={offline}
          openMixMatchBeam={currentMixMatchBeam}
          setOpenMixMatchBeam={setOpenMixMatchBeam}
          gridRef={gridRef}
          disableMixMatchButton={disableMixMatchButton}
          hideAddToList={hideAddToList}
          limit={limit}
          numberOfGridCols={numberOfGridCols}
          numberOfVouchers={(vouchers?.used?.length || 0) + (vouchers?.available?.length || 0)}
        />
      )}
    </Grid>
  );
};

export default ProductContainer;
